import { createFileRoute } from '@tanstack/react-router';
import { CreateFrameworkContractPage } from '@/pages/contract/framework-contract/create-framework-contract-page.tsx';

export const Route = createFileRoute('/_auth/rahmenvertrag/anlegen/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CreateFrameworkContractPage />;
}
